/**
 * created by wang lei
 字体背景颜色 页面
 *
 */
import React, {Component} from 'react';
import {toolWidth} from "../../twoLinesEditorToolsSpace";
import fontBgColorIcon from './fontBgColor.png';
import SketchColor from "../../../components/sketchColor/sketchColor";
import {Icon} from "antd";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

class FontBgColorTool extends Component {
    state={
          color:'#F5A623'
    };
    render() {
        let {color}=this.state
        return (
            <span style={{display:'inline-block',cursor:"pointer"}}>
                <span style={{display:'flex',alignItems: 'center'}} className={"editor-back-color-tool-btn"}>
                    <span onClick={() => {
                        this.props.editor.execCommand( 'backcolor', `${color}` )
                    }} style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        <img width={18} src={fontBgColorIcon}/>
                        <span style={{background: this.state.color, width: 15,height:3}}></span>
                    </span>
                    {/*颜色*/}
                    <SketchColor
                        setTooloColor={(hex)=>{
                            this.state.color = hex;
                            console.log(hex,'hex')
                            this.setState({},()=>{this.props.editor.execCommand('backcolor', `${hex}`);});
                        }}
                        showColorEle={false}
                        toolColor={this.state.color}
                        icon={<Icon type="caret-down"/>}
                        colorEleStyle={{
                            width:toolWidth,
                        }}
                        modalEleStyle={{ top: 120 ,right:530}}
                    />
                </span>
                <style>{`
                    .editor-back-color-tool-btn{
                        border: 1px solid #f2f6fc;
                        height: 23px
                    }
                    .editor-back-color-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-back-color-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </span>
        );
    }
}

export default FontBgColorTool;